/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AwardMedalIcon16Solid = forwardRef('AwardMedalIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.043 1.785 3.78 5.736A5.98 5.98 0 0 1 8 4a5.98 5.98 0 0 1 4.221 1.736l2.736-3.951A.5.5 0 0 0 14.546 1h-4.328a.5.5 0 0 0-.416.223L8 3.925 6.198 1.223A.5.5 0 0 0 5.782 1H1.454a.5.5 0 0 0-.41.785Z" }),
        React.createElement("path", { d: "M8 15A5 5 0 1 0 8 5a5 5 0 0 0 0 10Z" })));
});
